import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/components/vue-slideout-panel/eventBus.js